'use strict';
/**
 * Entry of the living table containing sockets still in use.
 */

var _classCallCheck = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var ELiving =
/*#__PURE__*/
function () {
  /**
     * @param {string} peerId The identifier of the peer reachable through the
     * socket.
     * @param {string} protocolId The identifier of the protocol that creates an
     * arc to this peer using this socket. Protocols can have multiple arcs
     * leading to a same peer. Multiple protocols can share a same socket.
     * @param {object} socket The WebRTC socket.
     */
  function ELiving(peerId, protocolId, socket) {
    _classCallCheck(this, ELiving);

    this.peer = peerId; // key

    this.socket = socket;
    this.protocols = new Map();
    this.increment(protocolId);
  }

  _createClass(ELiving, [{
    key: "increment",

    /**
       * Add an occurrence of the arc to the protocol
       * @param {string} protocolId The identifier of the protocol.
       */
    value: function increment(protocolId) {
      if (!this.protocols.has(protocolId)) {
        this.protocols.set(protocolId, 0);
      }

      ;
      this.protocols.set(protocolId, this.protocols.get(protocolId) + 1);
    }
  }, {
    key: "decrement",

    /**
       * Remove an occurrence of the arc to the protocol
       * @param {string} protocolId The identifier of the protocol.
       * @returns {boolean} True if an arc has been remove, false if the protocol
       * do not have such arc.
       */
    value: function decrement(protocolId) {
      var found = false;

      if (this.protocols.has(protocolId)) {
        this.protocols.set(protocolId, this.protocols.get(protocolId) - 1);

        if (this.protocols.get(protocolId) <= 0) {
          this.protocols.delete(protocolId);
        }

        ;
        found = true;
      }

      ;
      return found;
    }
  }, {
    key: "sum",

    /**
       * Count the number of arcs leading to this peer
       * @returns {integer} The sum of occurrences of protocols using this
       * socket.
       */
    value: function sum() {
      var result = 0;
      this.protocols.forEach(function (v, k) {
        result += v;
      });
      return result;
    }
  }]);

  return ELiving;
}();

;
module.exports = ELiving;